
import { XIcon } from "lucide-react";
import {
  MorphingDialog,
  MorphingDialogTrigger,
  MorphingDialogContainer,
  MorphingDialogContent,
  MorphingDialogClose,
} from "@/components/ui/morphing-dialog";

function ProjectVideo({ src, title }: { src: string; title?: string }) {
  // Check if the source is a YouTube embed URL
  const isYouTubeEmbed = src.includes('youtube.com/embed');

  return (
    <MorphingDialog
      transition={{
        type: "spring",
        bounce: 0,
        duration: 0.3,
      }}
    >
      <MorphingDialogTrigger>
        {isYouTubeEmbed ? (
          <div className="aspect-[1205/781] w-full h-full cursor-zoom-in rounded-xl overflow-hidden">
            <iframe 
              src={src}
              className="w-full h-full pointer-events-none"
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            ></iframe>
          </div>
        ) : (
          <video
            src={src}
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-contain cursor-zoom-in rounded-xl"
          />
        )}
      </MorphingDialogTrigger>
      <MorphingDialogContainer>
        <MorphingDialogContent className="relative flex items-center justify-center aspect-video rounded-2xl bg-zinc-50 p-1 ring-1 ring-zinc-200/50 ring-inset dark:bg-zinc-950 dark:ring-zinc-800/50 mx-auto">
          {isYouTubeEmbed ? (
            <iframe 
              src={src}
              className="aspect-video max-h-[50vh] w-full rounded-xl md:max-h-[70vh]"
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            ></iframe>
          ) : (
            <video
              src={src}
              autoPlay
              loop
              muted
              playsInline
              className="aspect-video max-h-[50vh] w-full rounded-xl md:max-h-[70vh] object-contain"
            />
          )}
        </MorphingDialogContent>
        <MorphingDialogClose
          className="fixed right-6 top-6 h-fit w-fit rounded-full bg-white p-1 z-50"
          variants={{
            initial: { opacity: 0 },
            animate: {
              opacity: 1,
              transition: { delay: 0.3, duration: 0.1 },
            },
            exit: { opacity: 0, transition: { duration: 0 } },
          }}
        >
          <XIcon className="h-5 w-5 text-zinc-500" />
        </MorphingDialogClose>
      </MorphingDialogContainer>
    </MorphingDialog>
  );
}

export { ProjectVideo };
